import React from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getBookmark, getFeedNormal, getPost} from "../../API/API";
import PostList from "../Feed/PostFeed/PostList";
import {Image, TouchableOpacity} from "react-native";

class BookmarkScreen extends React.Component{

    constructor(props) {
        super(props);

        this.state ={
            bookmark : [],
            feed : [],
            currentCursor : undefined,
            nextCursor : undefined,
        }

        this.setHeader = this.setHeader.bind(this);
        this.getFeed = this.getFeed.bind(this);
        this.getBookmark();
        this.setHeader();
    }

    componentDidUpdate() {
        this.setHeader();
    }

    setHeader(){
        const styleHeaderGlobalWhite = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;

        this.props.navigation.setOptions({
            headerTitle:this.props.t("Mes signets"),
            headerTitleAlign: "center",
            headerStyle: styleHeaderGlobalWhite,
            headerTitleStyle:{fontFamily: this.props.theme.fonts.title},
            headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                <Image resizeMode={"contain"} style={{width:20,marginLeft:10,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
            </TouchableOpacity>
        });
    }

    uniqueArray(arr1,arr2){
        let ids  = arr1.map((item)=>{return item.id});
        return  arr2.filter((item) =>{return !ids.includes(item.id);});
    }

    getFeed(){
        let bookMarks = this.state.bookmark;
          Promise.all(
            bookMarks.map((id)=>{
                return getPost(id);
                })
        ).then((data)=> {
                  this.setState({
                      feed: data
                  });
              }
          );
        //return bookMarks;
    }

    getBookmark(){
        getBookmark().then(data=>{
            this.state.bookmark = data
            this.setState({
                bookmark : data,
            });
            this.getFeed();
        });
    }

    filterPostSaved(){
       return  this.state.feed.filter((item)=>{
           return  this.state.bookmark.indexOf(item.id)!==-1
        });
    }

    render() {
        return (
            <PostList
                bookmark={this.state.bookmark}
                isExplorer={false}
                isActive={true}
                refNavigation={this.props.navigation}
                route={this.props.route}
                isRefresh={this.state.isRefresh}
                loadMore={()=> {}}
                refresh={this.getFeedNormal}
                data={this.filterPostSaved()} />
        );
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}


export default compose(withTranslation(),connect(mapStateToProps))(BookmarkScreen);
